export default {
  message: {
    "error": "Nagkaroon ng error!",
    "Sorrysomeerrorsoccurred": "Paumanhin, may ilang error na nangyari",
    "quit": "Lumabas",
    "language": "Wika",
    "Youcanchangethelanguagehere": "Magagawa mong baguhin ang wika dito!",
    "current": "Kasalukuyan",
    "home": "Bahay",
    "friends": "Kaibigan",
    "wallet": "Wallet",
    "aboutus": "Tungkol sa Amin",
    "Sharewithfriends": "Ibahagi sa mga kaibigan",
    "copyFailure": "Palpak na Kopya",
    "copySuccess": "Matagumpay na Kopya",
    "Claimreward": "Tanggapin ang gantimpala",
    "DailyLogin": "Pang-araw-araw na Pag-login",
    "noInvitationsYet": "Walang Imbitasyon Pa",
    "LoadMore": "Mag-load ng Higit Pa",
    "WatchAD": "Manood ng AD",
    "continue": "Magpatuloy",
    "Congratulations": "Binabati kita",
    "MyFriends": "Aking mga Kaibigan",
    "Invitefriends": "Mag-imbita ng mga kaibigan",
    "Invitepremiumfriends": "Mag-imbita ng mga premium na kaibigan",
    "DailyTasks": "Pang-araw-araw na mga gawain",
    "inviteDesc": "+{num} ${name} para sa bawat kaibigang iniiimbita mo",
    "DailyTasksDesc": "Tapusin ang mga gawain upang makakuha ng higit pang ${name}",
    "SponsorsandPartners": "Mga Sponsor at Kasosyo",
    "Receivingwallet": "Nakatanggap na wallet",
    "Enterwalletaddress": "Ipag-entrar ang {name} wallet address",
    "Claim": "Tanggapin",
    "Booster": "Booster",
    "RentPeriod": "Panahon ng Upa",
    "days30": "30 araw",
    "days": "araw",
    "Dailyprofit": "Pang-araw-araw na kita",
    "Totalprofit": "Kabuuang kita",
    "Quantity": "Dami",
    "RentPrice": "Presyo ng Upa",
    "RentMiner": "Uminom ng Miner",
    "Insufficient": "Hindi sapat na ${name}",
    "InsufficientMsg": "{num} ${name1} kinakailangan, mag-imbita ng mga kaibigan o tapusin ang mga gawain upang kumita ng higit pang ${name2}.",
    "Settings": "Mga Setting",
    "copyid": "Kopyahin ang ID",
    "UpgradeSuccessfully": "Matagumpay na Pag-upgrade",
    "Name": "Pangalan",
    "userinfo": "Impormasyon ng Gumagamit",
    "disconnect": "Mag-disconnect",
    "Startmining": "Simulan ang pagmimina",
    "Welcome": "Maligayang pagdating sa {name}",
    "Withdrawal": "Pag-withdraw",
    "Minimumamount": "Kminimum na halaga",
    "Networkfee": "Bayad ng network",
    "Enteramount": "Ilakad ang halaga",
    "Submit": "I-submit",
    "MinimumTip": "Ang halaga ng pag-withdraw ay masyadong maliit. Minimum na halaga ng pag-withdraw: {num}",
    "MaximumTip": "Kulang ang halaga, ang maximum na halaga na maaari mong i-withdraw ay: {num}",
    "SubmittedTip": "Naipasa na, inaasahang maproseso sa loob ng 30-60 araw ng trabaho",
    "WebSubmittedTip": "Naipasa na, inaasahang maproseso sa loob ng 24-48 oras",
    "WithdrawStatus": "Status",
    "Submissiontime": "Oras ng pagsusumite",
    "WithdrawAwaitTip": "* Tinatayang aabutin ng 30-60 araw ng trabaho. Ang pag-anyaya ng mas maraming kaibigan ay maaaring magpabilis sa proseso ng pagsusuri.",
    "WebWithdrawAwaitTip": "* Tinatayang aabutin ng 24-48 oras. Ang pag-anyaya ng mas maraming kaibigan ay maaaring magpabilis sa proseso ng pagsusuri.",
    "Processing": "Pinoproseso",
    "Success": "Tagumpay",
    "Rejection": "Pagsalungat",
    "Amount": "Halaga",
    "Numberoffriends": "Dami ng mga kaibigan: {now}/{limit}",
    "InviteTip": "Upang makagawa ng iyong unang pag-withdraw, kailangan mong anyayahan ang {limit} mga kaibigan na sumali sa mining app.",
    "openonphone": "Buksan ang link na ito sa iyong telepono.",
    "claimTip": "Ang halaga na kukunin ay masyadong maliit. Ang minimum na halaga na kukunin ay: {num}",
    "WalletBalance": "Balanseng Wallet",
    "Withdraw": "Mag-withdraw",
    "SetWalletAddress": "I-set ang Address ng Wallet",
    "WithdrawalRecord": "Tala ng Pag-withdraw",
    "Norecords": "Walang tala",
    "Whatis": "Ano ang {name}?",
    "All": "Lahat",
    "save": "Isalba",
    "successWithdrawal": "Natanggap na ang pag-withdraw {num}",
    "secondsago": "{time} segundo na ang nakalipas",
    "Loading": "Naglo-load...",
    "PaymentConfirming": "Sinusuri ang Status ng Transaksiyon...",
    "Check": "Suriin",
    "CheckFail": "Hindi natapos ang transaksiyon. Mangyaring suriin muli sa loob ng 5 segundo.",
    "Addname": "Idagdag ang '{name}' sa iyong pangalan",
    "Restattcheck": "I-restart ang app upang suriin",
    "Copyname": "Kopyahin ang '{name}'",
    "SubmissionFailed": "Nabigo ang pagsusumite, mangyaring subukan muli mamaya",
    "WithdrawalReview": "Pagsusuri ng pag-withdraw",
    "shop": "Tindahan",
    "topurchase": "Pumunta sa tindahan upang bumili",
    "shopDesc": "Limitado ang availability—kunin mo na bago ito mawala!",
    "select_payment_method": "Pumili ng paraan ng pagbabayad",
    "total_amount": "Kabuuang halaga",
    "creating_order": "Gumagawa ng order...",
    "order_created": "Order na nalikha",
    "order_status": "Status ng order",
    "claim": "Kunin",
    "payment_success": "Matagumpay ang pagbabayad",
    "payment_failed": "Nabigo ang pagbabayad",
    "payment_cancelled": "Kinansela ang pagbabayad",
    "opening_payment": "Nagbubukas ng pagbabayad...",
    "payment_status": "Katayuan ng pagbabayad",
    "create_order_failed": "Bigong lumikha ng order",
    "creating_ton_order": "Naglilikha ng order ng TON...",
    "next_step": "Susunod na hakbang",
    "use_ton_payment": "5Gumamit ng pagbabayad sa TON",
    "start_transaction": "Simulan ang transaksyon",
    "connect_wallet": "Ikonekta ang pitaka",
    "address": "Address",
    "amount_ton": "Halaga ng TON",
    "copy": "Kopyahin",
    "amount": "Halaga",
    "wallet_address": "Address ng pitaka",
    "comment_memo": "Comment memo",
    "you_can_choose_to_connect_wallet_to_pay": "Maaari mong piliing ikonekta ang pitaka upang magbayad",
    "or_manually_transfer_to_the_above_address": "O manu-manong ilipat sa itaas na address (tandaan na ang halaga at memo ay dapat na eksaktong pareho)",
    "transaction_success": "Tagumpay sa transaksyon",
    "transaction_failed": "Bigong transaksyon",
    "transaction_error": "Kamalian sa transaksyon",
    "transaction_status": "Katayuan ng transaksyon",
    "transaction_id": "Transaction ID",
    "transaction_amount": "Halaga ng transaksyon",
    "transaction_status_desc": "Paglalarawan ng katayuan ng transaksyon",
    "payment_status_tip": "Pakihintay na makumpirma ang pagbabayad",
    "Applyforwithdrawal": "Mag-apply para sa withdrawal",
    "Withdrawalunlock": "Pagbubukas ng withdrawal",
    "Close": "Isara",
    "Delivering": "Nagbibigay",
    "Duetothelargenumber": "Dahil sa malaking bilang ng mga tumatanggap, inaasahang darating ang iyong airdrop sa loob ng 15-20 araw ng trabaho",
    "WithdrawalunlockTip": "Kailangan mo ng {num} na inimbitahang kaibigan upang makumpleto ang mga gawain/magbinda ng pitaka upang ma-unlock ang withdrawal",
    "select_network": "Pumili ng network",
    "confirm": "Kumpirmahin",
    "switching_network": "Binabago ang network...",
    "network_switched": "Na-switch ang network",
    "use_usdt_payment": "Gamitin ang USDT na bayad",
    "or_manually_transfer_to_the_above_address_usdt": "Manu-manong ilipat sa itaas na address (tandaan na ang halaga at address ay dapat pareho)",
    "chain_type": "Network",
    "check_transaction_status": "Suriin ang katayuan ng transaksyon",
    "transaction_wait": "Pinoproseso ang transaksyon. Maaari kang lumabas sa app. Isang mensahe ang magbibigay alam sa iyo kapag ito ay kumpleto na.",
    "twa_pay_tip_with_memo": "Pakisigurado na ang address, halaga, at memo ay pare-pareho para sa paglilipat.",
    "twa_pay_tip": "Pakisigurado na ang address at halaga ay tama para sa paglilipat.",
    "creating_usdt_order": "Gumagawa ng USDT na order...",
    "affiliate_programs": "Programa ng Affiliate",
    "affiliate_programs_description": "Mag-imbita ng mga kaibigan na sumali sa mining app at kumita ng rewards.",
    "commission_details": "Mga detalye ng komisyon",
    "no_commission_records": "Walang tala ng komisyon",
    "commission_list": "Listahan ng komisyon",
    "input_amount": "Ilagay ang halaga",
    "max": "Max",
    "commission_input_amount": "Ilagay ang halaga ng komisyon",
    "min_commission": "Ang pinakamababang halaga ng withdrawal ay {num}",
    "WithdrawalSuccess": "Matagumpay ang withdrawal",
    "WithdrawalFailed": "Hindi matagumpay ang withdrawal",
    "WithdrawalProcessing": "Nasa proseso ang withdrawal",
    "award": "Gantimpala",
    "level": "Antas",
    "Share_to_group": "Ibahagi sa grupo",
    "Exchange": "Palitan",
    "balance_not_enough": "Hindi sapat ang balanse, maaari ka lamang magpalit ng {num} {coin}",
    "exchange_fail": "Nabigong magpalit",
    "exchange_success": "Matagumpay na nagpalit",
    "you_will_receive": "Makakatanggap ka ng",
    "ShareToGroups": "Ibahagi sa mga grupo",
    "Numberofgroups": "Bilang ng mga grupo: {now}/{limit}",
    "Confirm": "Kumpirmahin",
    "ShareToGroupsDesc": "Ibahagi sa mga grupo para makakuha ng higit pang {name}",
    "TokenAddress": "Pakisok ang mga detalye ng pag-alis tulad ng exchange ID o USDT address",
    "CashAddress": "Pakisok ang mga detalye ng pag-alis tulad ng numero ng bank card o USDT address",
    "Cancel": "Kanselahin",
    "min_withdrawal_amount": "Ang pinakamababang halaga ng pag-withdraw ay {num} {coin}",
    "max_withdrawal_amount": "Ang pinakamataas na halaga ng pag-withdraw ay {num} {coin}",
    "withdrawal_failed": "Hindi nagtagumpay ang pag-withdraw",
    "withdrawal_success": "Matagumpay ang pag-withdraw",
    "PayNow": "Magbayad na",
    "PaySkip": "Magbayad ng {num} para agad na ma-unlock ang pag-withdraw",
    "NumberofGroups": "Bilang ng mga grupo: {now}/{limit}",
    "SendMessage": "Magpadala ng mensahe",
    "NumberofShares": "Bilang ng mga bahagi: {now}/{limit}",
    "NumberofTasks": "Bilang ng mga gawain: {now}/{limit}",
    "CompleteTask": "Kompletuhin ang gawain",
    "PleaseEnterValidAmount": "Pakisokluhang Tamang Halaga",
    "PleaseEnterValidEmail": "Pakisokluhang Tamang Email",
    "Feedback": "Feedback",
    "Inputfeedbackcontent": "Ilagay ang nilalaman ng feedback",
    "Submitfeedback": "Ipadala ang feedback",
    "Pleaseenteravalidemailaddress": "Pakisokluhang tamang email address",
    "Pleaseenteryouremailaddress": "Pakisokluhang iyong email address",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Mayroon ka nang naibigay na feedback ngayon, pakibalik bukas",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Matagumpay na naipadala ang feedback, salamat sa iyong mahalagang feedback",
    "Feedback_submission_failed_please_retry": "Hindi matagumpay ang pagsusumite ng feedback, pakisubukang muli",
    "ContactUs": "Kontakin Kami",
    "XRPAddress": "Paki-kumpletuhin ang na-activate na XRP chain wallet address (kabilang ang MEMO), kung hindi ay hindi ka makakapag-withdraw ng cash.",
    "Accelerated": "Naitaguyod",
    "Accelerated_withdrawals_success": "Naitaguyod na pagkuha ng pera nang matagumpay",
    "login": "Mag-login",
    "register": "Magrehistro",
    "login_with_google": "Mag-login gamit ang Google",
    "or": "O",
    "email": "email",
    "password": "password",
    "no_account": "Wala kang account",
    "click_to_go": "I-click upang",
    "have_account": "May account ka na",
    "go_to": "Pumunta sa",
    "invite_code": "Kodigo ng Paanyaya",
    "optional": "Pil optional",
    "google_login_not_ready": "Ang Google login ay hindi handa, pakisubukan muli mamaya",
    "password_too_long": "Ang password ay masyadong mahaba",
    "weak": "Mahina",
    "medium": "Katamtaman",
    "strong": "Malakas",
    "login_success": "Matagumpay na pag-login",
    "login_failed": "Nabigong mag-login",
    "please_input_email": "Pakisubukan ang iyong email",
    "invalid_email": "Di-wasto ang anyo ng email",
    "please_input_password": "Pakisubukan ang iyong password",
    "password_length_6_to_16": "Ang password ay dapat 6-16 na karakter",
    "account_or_password_error": "Pagkakamali sa account o password",
    "register_success": "Matagumpay na pagpaparehistro",
    "register_failed": "Nabigong pagpaparehistro",
    "save_error": "Pagkapahamak ng pag-save, pakiulit mamaya",
    "ShareToFriends": "Ibahagi sa mga kaibigan",
    "login_first": "Paki-login muna",
    "WalletBscError": "❌ Hindi wastong address ng BNB Chain wallet.",
    "DownloadWallet": "I-download ang Wallet",
    "AddToHomeScreen": "Idagdag ang {appName} sa home screen",
    "TapShareInToolbar": "Tapikin ang toolbar",
    "SelectAddToHomeScreen": "Pumili ng idagdag sa home screen",
    "OpenToolbar": "Buksan ang Toolbar",
    "ClaimFailed": "Pagkolekta ng gantimpala ay nabigo, pakisubukang muli mamaya",
    "guest_login": "Pag-login bilang Bisita",
    "please_input_phone": "Paki-enter ang iyong numero ng telepono",
    "email_error_1": "Paki-enter ang iyong email",
    "email_error_2": "Paki-enter ang wastong adres ng email",
    "email_error_3": "Ang email ng bisita ay hindi pinahihintulutan, paki-gamit ang tunay na email",
    "phone": "Telepono",
    "phone_error_1": "Paki-enter ang iyong numero ng telepono",
    "phone_error_2": "Paki-enter ang wastong numero ng telepono",
    "update_info": "I-update ang Impormasyon",
    "update_success": "Matagumpay ang pag-update",
    "update_failed": "Ang pag-update ay nabigo, paki-subukan muli mamaya",
    "cancel": "Ikansela",
    "guest_credentials_title": "Impormasyon ng Account",
    "guest_credentials_warning": "Pakikuha ng screenshot upang i-save ang iyong account at password. Kung mawawala, hindi maibabalik ang iyong kita!",
    "i_have_saved": "Naitabi ko na",
    "account": "Account",
    "view_credentials": "Tingnan ang Mga Kredensyal",
    "miner_max_reached": "Nakarating ka na sa pinakamataas na bilang ng minero na ito"
}};